import React from "react";
import { Building2, Barcode, Warehouse } from "lucide-react";
import { WarehouseDetails } from "src/types";
import { CollapsibleSection } from "src/components/ui/collapsible";

interface WarehouseDetailsSectionProps extends WarehouseDetails {
  initiallyOpen?: boolean;
  withCollapsible?: boolean;
}

const WarehouseCheckInWarehouseDetailsSection: React.FC<WarehouseDetailsSectionProps> = ({
  warehouseCompany,
  warehouseId,
  initiallyOpen = false,
  withCollapsible = true
}) => {
  if (!warehouseCompany && !warehouseId) {
    return null;
  }

  const content = (
    <div className="p-6 space-y-4">
      {warehouseCompany && (
        <div className="bg-secondary-50 rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-2">
            <Building2 className="w-4 h-4 text-primary-600" />
            <span className="text-xs font-semibold uppercase tracking-wide text-secondary-700">Warehouse Company</span>
          </div>
          <p className="text-sm font-medium text-secondary-900">{warehouseCompany}</p>
        </div>
      )}

      {warehouseId && (
        <div className="bg-secondary-50 rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-2">
            <Barcode className="w-4 h-4 text-primary-600" />
            <span className="text-xs font-semibold uppercase tracking-wide text-secondary-700">Warehouse ID</span>
          </div>
          <p className="text-sm font-medium text-secondary-900">{warehouseId}</p>
        </div>
      )}
    </div>
  );

  if (!withCollapsible) {
    return (
      <section className="rounded-2xl border border-secondary-200 bg-white shadow-soft">
        <div className="flex items-center gap-2 border-b border-secondary-100 px-6 py-4">
          <Warehouse className="h-5 w-5 text-primary-600" />
          <h3 className="text-base font-semibold text-secondary-900">Warehouse Details</h3>
        </div>
        {content}
      </section>
    );
  }

  return (
    <div className="bg-white border border-secondary-200 rounded-xl shadow-soft overflow-hidden">
      <CollapsibleSection
        initiallyOpen={initiallyOpen}
        title={
          <h3 className="text-lg font-semibold text-secondary-800 flex items-center">
            <Warehouse className="w-5 h-5 mr-2 text-primary-600" />
            Warehouse Details
          </h3>
        }
      >
        {content}
      </CollapsibleSection>
    </div>
  );
};

export { WarehouseCheckInWarehouseDetailsSection };
